export default __webpack_public_path__ + "static/media/item2.e4548de9.png";